import type {
  AddConditionAction,
  AddEffectAction,
  AddHandlerAction,
  AddResponseAction,
  AddTriggerAction,
  AddTriggerCaseAction,
  MoveConditionAction,
  RemoveConditionAction,
  RemoveEffectAction,
  RemoveHandlerAction,
  RemoveAllTriggersAction,
  RemoveResponseAction,
  RemoveTriggerAction,
  RemoveTriggerCaseAction,
  ReorderConditionAction,
  ReorderEffectAction,
  ReorderHandlerAction,
  ReorderResponseAction,
  ReorderTriggerAction,
  UpdateConditionConfigAction,
  UpdateEffectConfigAction,
  UpdateHandlerAction,
  UpdateResponseAction,
  UpdateTriggerAction,
  UpdateTriggerCaseAction,
} from "../../../schemas/index.ts";
import { createNodeDesignsAction } from "../shared.ts";

export const removeTriggerAction = createNodeDesignsAction<RemoveTriggerAction>("REMOVE_TRIGGER");

export const removeAllTriggersAction = createNodeDesignsAction<RemoveAllTriggersAction>("REMOVE_ALL_TRIGGERS");

export const addTriggerAction = createNodeDesignsAction<AddTriggerAction>("ADD_TRIGGER");

export const updateTriggerAction = createNodeDesignsAction<UpdateTriggerAction>("UPDATE_TRIGGER");

export const addTriggerCaseAction = createNodeDesignsAction<AddTriggerCaseAction>("ADD_TRIGGER_CASE");

export const updateTriggerCaseAction = createNodeDesignsAction<UpdateTriggerCaseAction>("UPDATE_TRIGGER_CASE");

export const removeTriggerCaseAction = createNodeDesignsAction<RemoveTriggerCaseAction>("REMOVE_TRIGGER_CASE");

export const addHandlerAction = createNodeDesignsAction<AddHandlerAction>("ADD_HANDLER");

export const updateHandlerAction = createNodeDesignsAction<UpdateHandlerAction>("UPDATE_HANDLER");

export const removeHandlerAction = createNodeDesignsAction<RemoveHandlerAction>("REMOVE_HANDLER");

export const reorderHandlerAction = createNodeDesignsAction<ReorderHandlerAction>("REORDER_HANDLER");

export const addResponseAction = createNodeDesignsAction<AddResponseAction>("ADD_RESPONSE");

export const updateResponseAction = createNodeDesignsAction<UpdateResponseAction>("EDIT_RESPONSE");

export const removeResponseAction = createNodeDesignsAction<RemoveResponseAction>("REMOVE_RESPONSE");

export const reorderResponseAction = createNodeDesignsAction<ReorderResponseAction>("REORDER_RESPONSE");

export const reorderTriggerAction = createNodeDesignsAction<ReorderTriggerAction>("REORDER_TRIGGER");

export const addEffectAction = createNodeDesignsAction<AddEffectAction>("ADD_EFFECT");

export const updateEffectAction = createNodeDesignsAction<UpdateEffectConfigAction>("UPDATE_EFFECT_CONFIG");

export const removeEffectAction = createNodeDesignsAction<RemoveEffectAction>("REMOVE_EFFECT");

export const addConditionAction = createNodeDesignsAction<AddConditionAction>("ADD_CONDITION");

export const updateConditionAction = createNodeDesignsAction<UpdateConditionConfigAction>("UPDATE_CONDITION_CONFIG");

export const removeConditionAction = createNodeDesignsAction<RemoveConditionAction>("REMOVE_CONDITION");

export const moveConditionAction = createNodeDesignsAction<MoveConditionAction>("MOVE_CONDITION");

export const reorderConditionAction = createNodeDesignsAction<ReorderConditionAction>("REORDER_CONDITION");

export const reorderEffectAction = createNodeDesignsAction<ReorderEffectAction>("REORDER_EFFECT");
